import CreditCalc from "../classes/CreditCalc";

$(document).ready(function () {
    if ($('#credit-calc').length)
        CreditCalc.get('#credit-calc');
});